import PrintTasksContainer from 'containers/Tasks/TasksManagement/PrintSingleTask/PrintTasksContainer';
import React from 'react';
import Helmet from 'react-helmet';
import { Router, Redirect, navigate } from '@reach/router';
import { MapStateToProps, connect, MapDispatchToProps } from 'react-redux';
import { RootState } from 'store/store';
import { getDomainAndPort } from 'api/Utils';
import { isProduction } from 'api/Utils';
import CompaniesList from 'containers/Tasks/CompanyManagement/CompaniesList';
import CompanyEditor from 'containers/Tasks/CompanyManagement/CompanyEditor';
import CompanyMembers from 'containers/Tasks/CompanyManagement/CompanyMembers';
import CompanyRoles from 'containers/Tasks/CompanyManagement/CompanyRoles/CompanyRoles';
import CompanyPermissionSchemes from 'containers/Tasks/CompanyManagement/CompanyPermissionSchemes/CompanyPermissionSchemes';
import CompanyTemplateEditor from 'containers/Tasks/TemplatesManagement/CompanyTemplateEditor';
import CompanyTemplatesList from 'containers/Tasks/TemplatesManagement/CompanyTemplatesList';
import Contents from 'containers/Profile/Content/Contents';
import DirectMessages from 'containers/Tasks/Directs/DirectMessages';
import InboxContainer from 'containers/Tasks/Inbox/InboxContainer';
import IndexRouter from 'containers/App/IndexRouter';
import Logout from 'containers/Logout';
import NotFoundPage from 'containers/NotFoundPage';
import ProfileContainer from 'containers/Tasks/UserProfile/ProfileContainer';
import ProjectTemplates from 'containers/Tasks/ProjectManagement/ProjectTemplates';
import ProjectMembers from 'containers/Tasks/ProjectManagement/ProjectMembers';
import ProjectEditor from 'containers/Tasks/ProjectManagement/ProjectEditor';
import ProjectsList from 'containers/Tasks/ProjectManagement/ProjectsList';
import CompanyAdmin from 'containers/Tasks/TasksManagement/CompanyAdmin';
import ProviderTemplateContainer from 'containers/ProviderTemplates/ProviderTemplateContainer';
import ProviderTemplateEditor from 'containers/ProviderTemplates/ProviderTemplateEditor';
import ProviderTemplatesList from 'containers/ProviderTemplates/ProviderTemplatesList';
import ContentSearch from 'containers/Profile/Content/ContentSearch';
import TagsContainer from 'containers/Tags/TagsContainer';
import TaskEditorWrapper from 'containers/Tasks/TasksManagement/TaskEditorWrapper';
import TasksContainer from 'containers/Tasks/TasksManagement/TasksContainer';
import ContentSettings from 'containers/Profile/Content/ContentSettings';
import DirectContent from '../Profile/Content/DirectContent';
import MobileProfileContainer from '../Mobile/Profile/MobileProfileContainer';
import ChangePhonePage from '../ChangePhonePage/ChangePhonePage';
import MakhsanPanel from '../MakhsanPanel/MakhsanPanel';
import ImagePrint from '../ImagePrint';
import { getRedirectToLoginLocation } from 'utils/happyFunctions';
import ProjectCreator from '../Tasks/ProjectManagement/ProjectCreator';
import initFirebase from '../../utils/firebase';
import ContentManagement from 'containers/Profile/Content/ContentManagement';
import { LoginModal } from 'containers/LoginModal/LoginModal';
import LoginPage from 'containers/LoginPage';
import PrintTaskReport from 'components/Report/PrintTaskReport';
import { PrintSurveyResponse } from 'components/Chart/PrintSurveyResponse';
import PrintReport from 'components/Chart/PrintReport';
import PrintSingleTaskContainer from 'containers/Tasks/TasksManagement/PrintSingleTask/PrintSingleTaskContainer';
import PrintTasks from 'containers/Tasks/TasksManagement/PrintTasks';
import TasksManagement from 'containers/Tasks/TasksManagement';
import WizardContainer from 'containers/Profile/Wizard/WizardContainer';
import PrintResponses from 'containers/PrintResponses';
import LottyLoading from 'components/LottyLoading';
import CompanyDocuments from '../Tasks/CompanyManagement/CompanyDocuments/CompanyDocuments';
import NewHospital from '../NewHospital/NewHospital';
import PdpConfig from '../Tasks/CompanyManagement/PDPConfig/pdpConfig';
import PDPPanel from '../Tasks/TasksManagement/PDPPanel';
import TopicManager from '../Tasks/CompanyManagement/PDPTopics/TopicManager';
import TermManager from '../Tasks/CompanyManagement/PDPTerms/TermManager';
import PDPPersonManager from '../Tasks/CompanyManagement/PDPPersonManager/PDPPersonManager';
import ClassManager from '../Tasks/CompanyManagement/PDPClass/ClassManager';
import { addGuideToList } from 'store/siteGuide/SiteGuideSlice';
import { appDispatch } from 'store/store';
import 'i18n';
import {
  getUserFlags,
  IThisUserState,
  submitSingleDevice,
  submitSingleDeviceFn,
} from 'store/thisUser/thisUserSlice';
import { ICompanyState } from 'store/companies/companiesTypes';
import {
  requireConversation,
  requireConversationFn,
} from 'store/conversation/conversationSlice';
import {
  requireNewMessages,
  requireNewMessagesFn,
} from 'store/messages/messagesSlice';
import { identifyUser, initializeLogRocket } from 'api/services';
import { parse } from 'query-string';
import { setSingleTaskAccessToken } from '../../store/session/SessionSlice';
import SessionTracking from '../../utils/mixpanel/SessionTracking';
import LanguageProvider from '../../context/i18n/themeProvider';
import NotFoundContactSupport from '../NotFoundPage/NotFoundContactSupport';
import { HolidayProvider } from '../../context/HolidayProvider/HolidayProvider';
// import GTranslateWidget from '../../components/GTranslateWidget/GTranslateWidget';
import SafeNavigateProvider from '../../context/SafeNavigate/SafeNavigateProvider';
import HISSMSConfiguration from '../HIS/HISSMSConfiguration';
import SmsPanel from '../SmsPanel/SmsPanel';
import AdminSmsPanel from '../Tasks/CompanyManagement/AdminSmsPanel';
import CompanyHomePage from '../HomePage/CompanyHomePage';
import HomePage from '../HomePage/HomePage';
import OldHomePage from '../HomePage/OldHomePage';
import TourWrapper from '../../context/Tour/TourWrapper';
import { blue, darkGray } from '../../utils/style/colors';
import { TourProvider } from '@reactour/tour';
import i18n from 'i18next';
import Icon from '../../components/Icon';
import EmtpyRoute from './EmtpyRoute';
import SubCompany from 'containers/Tasks/CompanyManagement/SubCompany/SubCompany';
import { toggleDOMToLightMode, toggleToDarkMode } from 'hooks/DarkModeClass';
// import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';

const JSWizardContainer = WizardContainer as any;
const {
  title: appTitle,
  homeProfile,
  view,
  enableLogRocket,
  loginProps,
  domainFeatures,
} = getDomainAndPort();

interface IStateToProps {
  thisUser: IThisUserState;
  companies: ICompanyState;
  isThemeDark: boolean;
}

interface IDispatchToProps {
  requireConversation: (
    inboxId: number
  ) => ReturnType<typeof requireConversationFn>;
  requireNewMessages: (
    conversationId: number,
    messageId: number,
    conversationToken?: string
  ) => ReturnType<typeof requireNewMessagesFn>;
  submitSingleDevice: (
    name: string,
    token: string
  ) => ReturnType<typeof submitSingleDeviceFn>;
  addGuideToRelated: (guideKey: string | Array<string>) => void;
}

interface IOwnProps {}

type IComponentProps = IStateToProps & IDispatchToProps & IOwnProps;
interface IComponentState {
  firebaseRegistered: boolean;
  currentStep: number;
}
function grabAllInternalLinks() {
  function callback(e: any) {
    if (e?.target?.tagName !== 'A' && e?.target.parentElement?.tagName !== 'A')
      return;
    const href =
      e?.target?.getAttribute('href') ||
      e?.target?.parentElement.getAttribute('href');
    const target =
      e?.target?.getAttribute('target') ||
      e?.target?.parentElement.getAttribute('target');
    if (
      href?.startsWith('/') &&
      target !== '_blank' &&
      e.target.closest('.ck-view')
    ) {
      e.preventDefault();
      navigate(href);
    }

    if (href?.startsWith('#') && e.target.closest('.ck-view')) {
      $('html, body')?.animate(
        {
          scrollTop: $(href)?.offset()?.top,
        },
        800
      );
    }
  }

  if (document.addEventListener)
    document.addEventListener('click', callback, false);
  else if ((document as any).attachEvent)
    (document as any).attachEvent('onclick', callback);
}

function isPrintThemeRoute(pathname: string): boolean {
  if (pathname.startsWith('/print/')) return true;
  if (pathname.includes('/print/')) return true;
  if (pathname.includes('/task/print/')) return true;
  if (pathname.includes('/tasks/print/')) return true;
  return false;
}

class App extends React.Component<IComponentProps, IComponentState> {
  state = {
    firebaseRegistered: false,
    currentStep: 0,
  };

  componentDidMount = async () => {
    const { thisUser, isThemeDark } = this.props;
    this.fetchFlags();
    const isLoggedIn = thisUser ? thisUser.isLoggedIn : false;
    const isDarkMode = localStorage.getItem('dark-mode') === 'true';

    if (isDarkMode && !isThemeDark) {
      toggleToDarkMode();
    }

    if (isDarkMode && isPrintThemeRoute(window.location.pathname)) {
      toggleDOMToLightMode();
    }

    if (isProduction() && enableLogRocket) {
      // uncomment to use logrocket
      if (thisUser) {
        const userId = thisUser.userId;
        initializeLogRocket();
        if (userId) identifyUser(userId, thisUser.name || 'no-name');
      }
    }
    if (
      window.location.pathname === '/content/714' &&
      window.location.host.endsWith('app.rastech.ir')
    ) {
      window.location.href = window.location.href.replaceAll(
        '/content/714',
        '/content/2/f/130518'
      );
    }
    if (
      window.location.href.includes('/content/714') &&
      window.location.host.endsWith('app.rastech.ir')
    ) {
      window.location.href = window.location.href.replaceAll(
        '/content/714',
        '/content/2'
      );
    }

    if (
      domainFeatures &&
      domainFeatures.requireLogin &&
      !isLoggedIn &&
      !(
        window.location.pathname.startsWith('/login') ||
        window.location.pathname.startsWith('/_/login')
      )
    ) {
      window.location.href = getRedirectToLoginLocation('login');
    }

    const parsed = parse(window.location!.search);
    if (parsed?.tt) {
      appDispatch(
        setSingleTaskAccessToken((parsed.tt as string).replace(' ', '+'))
      );
    }
    grabAllInternalLinks();

    const isIOS = navigator.userAgent.match(/iPhone|iPad|iPod/);
    if (isIOS) {
      const setViewport = () => {
        const viewport = document.querySelector('meta[name="viewport"]');
        if (viewport) {
          const currentContent = viewport.getAttribute('content') || '';
          if (!currentContent.includes('maximum-scale=1.0')) {
            viewport.setAttribute(
              'content',
              'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
            );
          }
        }
      };
      setViewport();

      const viewportMeta = document.querySelector('meta[name="viewport"]');
      if (viewportMeta) {
        const observer = new MutationObserver(() => {
          setViewport();
        });

        observer.observe(viewportMeta, {
          attributes: true,
          attributeFilter: ['content'],
        });

        const headObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach((node) => {
                if (
                  node.nodeType === 1 &&
                  (node as Element).tagName === 'META' &&
                  (node as Element).getAttribute('name') === 'viewport'
                ) {
                  setViewport();
                  observer.observe(node as Element, {
                    attributes: true,
                    attributeFilter: ['content'],
                  });
                }
              });
            }
          });
        });

        headObserver.observe(document.head, {
          childList: true,
          subtree: true,
        });
      }

      const style = document.createElement('style');
      style.id = 'ios-no-zoom-style';
      style.textContent = `
        input[type="text"],
        input[type="email"],
        input[type="number"],
        input[type="tel"],
        input[type="password"],
        input[type="search"],
        input[type="url"],
        textarea,
        select {
          font-size: 16px !important;
        }
      `;
      if (!document.getElementById('ios-no-zoom-style')) {
        document.head.appendChild(style);
      }
    }
  };

  componentDidUpdate(prevProps: Readonly<IComponentProps>): void {
    if (
      this.props.thisUser?.register === 'Registered' &&
      this.props.thisUser?.userId !== prevProps.thisUser?.userId
    ) {
      this.fetchFlags();
    }
    if (
      Object.keys(this.props.companies.data).length &&
      !this.state.firebaseRegistered
    ) {
      initFirebase(
        this.props.thisUser,
        this.props.submitSingleDevice,
        this.props.requireConversation,
        this.props.requireNewMessages
      );
      this.setState({ firebaseRegistered: true });
    }
  }

  private fetchFlags = async () => {
    if (this.props.thisUser.isLoggedIn) {
      await appDispatch(getUserFlags({ flagGroup: 'tour' }));
      await appDispatch(getUserFlags({ flagGroup: 'homepage' }));
    }
  };

  render() {
    const stepList = [] as any;

    if (view === 'public' || view === 'publicSingle') {
      return (
        // <ErrorBoundary>
        <HolidayProvider>
          <SessionTracking>
            <LanguageProvider>
              {/*{getDomainAndPort().domainFeatures?.directTranslation && (
                <GTranslateWidget />
              )}*/}
              <Helmet
                titleTemplate={`%s - ${appTitle}`}
                defaultTitle={appTitle}
                meta={[{ name: 'description', content: `${appTitle}` }]}
              >
                <meta
                  name="viewport"
                  content="width=device-width, initial-scale=1, maximum-scale=5"
                />
              </Helmet>
              {window.location.pathname !== '/login' && <LoginModal />}
              <React.Suspense
                fallback={<LottyLoading src={'/assets/loading.json'} />}
              >
                <Router role="group">
                  <MobileProfileContainer
                    forceSingle={view === 'publicSingle'}
                    path="/"
                    providerId={homeProfile!.toString()}
                  />
                  <MobileProfileContainer
                    path="/:providerId/f/:folderId"
                    // forceSingle={view === 'publicSingle'}
                  />
                  <Redirect
                    from="m/:providerId/f/:folderId"
                    to="/:providerId/f/:folderId"
                  />
                  <MobileProfileContainer
                    path="/:providerId"
                    // forceSingle={view === 'publicSingle'}
                  />
                  <DirectContent path="content/:providerId/direct/:itemId" />
                  <DirectContent path="c/:providerId/d/:itemId" />
                  <Redirect from="m/:providerId" to="/:providerId" />
                  <Redirect from="/login" to="/_/login" />
                  <LoginPage path="_/login" loginProps={loginProps} />
                  <Logout path="_/logout" />
                  <NotFoundPage default={true} />
                </Router>
              </React.Suspense>
            </LanguageProvider>
          </SessionTracking>
        </HolidayProvider>
        // {/*</ErrorBoundary>*/}
      );
    } else
      return (
        // <ErrorBoundary>
        <HolidayProvider>
          <TourProvider
            showDots={true}
            steps={stepList}
            showPrevNextButtons={true}
            scrollSmooth={true}
            rtl={i18n.dir() === 'rtl'}
            nextButton={(props) => {
              const isLast =
                props.currentStep === (props.steps?.length ?? 0) - 1;
              return (
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    isLast
                      ? props.setIsOpen(false)
                      : props.setCurrentStep(props.currentStep + 1)
                  }
                >
                  <span>
                    {
                      i18n.t(isLast ? 'close' : 'next', {
                        ns: 'general',
                      }) as string
                    }
                  </span>
                  <Icon color={'white'} type={isLast ? 'x' : 'arrow-left'} />
                </span>
              );
            }}
            prevButton={(props) => {
              const isFirst = props.currentStep === 0;
              if (isFirst) return <span></span>;
              return (
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={() => props.setCurrentStep(props.currentStep - 1)}
                >
                  <Icon color={'white'} type={'arrow-right'} />
                </span>
              );
            }}
            styles={{
              popover: (base) => ({
                ...base,
                backgroundColor: `${darkGray}`,
                color: 'var(--exact-white)',
                borderRadius: '0.5rem',
                padding: '16px',
                paddingTop: '3rem',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                zIndex: 1000_000,
              }),
              badge: (base) => ({
                ...base,
                width: '2rem',
                height: '2rem',
                background: `${blue}`,
                display: 'flex',
                alignItems: 'center',
                zIndex: 1000_000,
                justifyContent: 'center',
              }),
              arrow: (base) => ({
                ...base,
                color: 'var(--exact-white)',
                padding: '0.7rem 0.5rem',
                height: '2rem',
                width: '2rem',
                border: '1px solid var(--exact-white)',
                zIndex: 1000_000,
                borderRadius: '12rem',
              }),
              maskArea: (base) => ({
                ...base,
                zIndex: 1000_000,
              }),
            }}
          >
            <TourWrapper>
              <SessionTracking>
                <LanguageProvider>
                  {/*{getDomainAndPort().domainFeatures?.directTranslation && (
                    <GTranslateWidget />
                  )}*/}
                  <Helmet
                    titleTemplate={`%s - ${appTitle}`}
                    defaultTitle={appTitle}
                    meta={[
                      {
                        name: 'description',
                        content: `سامانه‌ی ${appTitle}`,
                      },
                    ]}
                  >
                    <meta
                      name="viewport"
                      content={
                        navigator.userAgent.match(/iPhone|iPad|iPod/)
                          ? 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
                          : 'width=device-width, initial-scale=1, maximum-scale=5'
                      }
                    />
                  </Helmet>
                  {window.location.pathname !== '/login' && <LoginModal />}
                  <React.Suspense fallback={<div />}>
                    <Router>
                      <SafeNavigateProvider path="/">
                        <OldHomePage path="oldhomepage" />
                        <DirectContent path="content/:providerId/direct/:itemId" />
                        <DirectContent path="c/:providerId/d/:itemId" />
                        <MobileProfileContainer path=":providerId/f/:folderId" />
                        <MobileProfileContainer path=":providerId" />
                        <SmsPanel path="sms-panel" />
                        <HomePage path="homepage" />
                        <Redirect from="home" to="/homepage" />
                        <IndexRouter path="/">
                          <ContentManagement path="content/:providerId/f/:folderId">
                            <Contents path="/" />
                            <ContentSearch path="/search" />
                            <NotFoundPage default={true} />
                          </ContentManagement>
                          <ContentManagement path="content/:providerId">
                            <Contents path="/" />
                            <Contents path="/access/:roleId" />
                            <ContentSearch path="/search" />
                            <ContentSettings path="/settings" />
                            <TagsContainer path="tags" />
                            <TagsContainer path="tags/:tagPath" />
                            <ProviderTemplateContainer path="templates">
                              <ProviderTemplatesList path="/" />
                              <ProviderTemplateEditor path="editor" />
                              <ProviderTemplateEditor path="editor/:templateId" />
                            </ProviderTemplateContainer>
                            <NotFoundPage default={true} />
                          </ContentManagement>
                          <TasksManagement path="t/:companyId">
                            <PDPPanel path="pdp/:pdpId">
                              <TopicManager path="topics" />
                              <TermManager path="terms/:termId/:page">
                                <EmtpyRoute path=":classId" />
                              </TermManager>

                              {/* <TermManager path="terms/:termId/:page/:classId" /> */}
                              <TermManager path="terms">
                                <Contents
                                  path="documents"
                                  custom="pdpDocuments"
                                />
                                <TopicManager path="topics" />
                              </TermManager>
                              <ClassManager path="class/:classId" />
                              <PDPPersonManager path="term/:termId" />
                            </PDPPanel>
                            <CompanyAdmin path="admin">
                              <ProjectsList path="project/list" />
                              <ProjectCreator path="project/create" />
                              <ProjectEditor path="project/editor/:projectId" />
                              <CompanyDocuments path="documents" />
                              <ProjectMembers path="project/:projectId/members" />
                              <ProjectTemplates path="project/:projectId/templates" />
                              <CompanyTemplatesList path="template/list" />
                              <CompanyTemplateEditor path="template/editor/:templateId" />
                              <CompanyTemplateEditor path="template/editor" />
                              <CompanyMembers path="members" />
                              <CompanyRoles path="roles" />
                              <PdpConfig path="pdp" />
                              <AdminSmsPanel path="sms-panel" />
                              <CompanyPermissionSchemes path="permissionSchemes" />
                              <SubCompany path="subCompany" />
                            </CompanyAdmin>
                            <InboxContainer path="inbox" />
                            <DirectMessages path="messages" />
                            <DirectMessages path="messages/:chatId" />
                            <TasksContainer path="task">
                              <TaskEditorWrapper path="editor" />
                              <TaskEditorWrapper path="editor/:taskId/:tab" />
                            </TasksContainer>
                            <TaskEditorWrapper
                              path="dt/:taskId"
                              embedded
                              directTask
                            />
                            <TaskEditorWrapper
                              path="dt/:taskId/info"
                              embedded
                              directTask
                            />
                            <TaskEditorWrapper
                              path="dt/:taskId"
                              embedded
                              directTask
                            />
                            <TasksContainer path="project/:projectId/task">
                              <TaskEditorWrapper path="editor" />
                              <TaskEditorWrapper path="editor/:taskId/:tab" />
                            </TasksContainer>

                            <CompanyHomePage path="home">
                              <TaskEditorWrapper path="editor" />
                              <TaskEditorWrapper path="editor/:taskId/:tab" />
                            </CompanyHomePage>
                            <NotFoundPage path={'notfound'} />
                          </TasksManagement>
                        </IndexRouter>
                        {/*<NewUIViraPage path="/newui" />*/}
                        <ChangePhonePage path="/admin/changePhone" />
                        <MakhsanPanel path="/makhsan/panel" />
                        <HISSMSConfiguration path="/hissms" />
                        <NewHospital path="/new/hospital" />
                        <ImagePrint path="/tools/imagePrint" />
                        <Redirect
                          from="p/:providerId"
                          to="content/:providerId"
                          noThrow={true}
                        />
                        <TasksManagement path="c">
                          <CompaniesList path="company/list" />
                          <CompanyEditor path="company/editor/:companyId" />
                          <CompanyEditor path="company/editor" />
                          <ProfileContainer path="profile" />
                          <NotFoundPage default={true} />
                        </TasksManagement>
                        <LoginPage path="login" loginProps={loginProps} />
                        <Logout path="logout" />
                        <JSWizardContainer path="wizard" />
                        <PrintTaskReport path="/t/:companyId/print/tasks_report" />
                        <PrintTasks path="/t/:companyId/print/tasks" />
                        <PrintSingleTaskContainer path="/t/:companyId/task/print/:taskId" />
                        <PrintTasksContainer path="/t/:companyId/tasks/print/:parentId/:tasksId" />
                        <PrintSurveyResponse path="/print/response" />
                        <PrintReport path="/print/survey" />
                        <PrintResponses path="/print/responses" />
                        <NotFoundContactSupport path="/notfound-support" />
                        <NotFoundPage default={true} />
                      </SafeNavigateProvider>
                    </Router>
                  </React.Suspense>
                </LanguageProvider>
              </SessionTracking>
            </TourWrapper>
          </TourProvider>
        </HolidayProvider>
        //</ErrorBoundary>
      );
  }
}

const mapStateToProps: MapStateToProps<
  IStateToProps,
  IComponentProps,
  RootState
> = (state) => {
  const thisUser = state.thisUser;
  const companies = state.companies;
  const isThemeDark = state.app.UI.themeMode === 'dark';

  return { thisUser, companies, isThemeDark };
};
// @ts-expect-error it's ok
const mapDispatchToProps: MapDispatchToProps<
  IDispatchToProps,
  IOwnProps
> = () => ({
  requireConversation: (inboxId: number) =>
    appDispatch(requireConversation({ conversationId: inboxId })),
  requireNewMessages: (
    conversationId: number,
    messageId: number,
    conversationToken: string
  ) =>
    appDispatch(
      requireNewMessages({ conversationId, messageId, conversationToken })
    ),
  submitSingleDevice: (name: string, token: string) =>
    appDispatch(submitSingleDevice({ name, token })),

  addGuideToRelated: (guideKey: string | Array<string>) => {
    appDispatch(addGuideToList(guideKey));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
